import $ from 'jquery';

export function cancelRental(id){

  return $.ajax({
    method: "POST",
    dataType: 'json',
    traditional: true,
    data: {},
    xhrFields: {
      withCredentials: true
   },
    url: `${process.env.REACT_APP_API}/rentals/${id}/cancel`,
    
    headers: {
        "Authorization": "Bearer " + localStorage.getItem('accessToken'),
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    },
  }).then(res => res).catch(res => res)
}